import { Outlet } from 'react-router-dom'
import '../Layout.css'
import Header from "../components/layout/Header";
import Menu from "../components/layout/Menu";
import withAuth from "../helper/withAuth";

function Layout() {
    return <div className='p-3'>
            <Header />
            <Menu />
            <div className='mt-3 shadow default-bg rounded-b-sm p-2 py-5 md:w-[95%] mx-auto'>
                <Outlet />
            </div>
        </div>
}

export default withAuth(Layout)